export default "__VITE_ASSET__Dc4Pd1m$__"